import React, { useEffect, useState } from "react";
// Components
import { CommunitiesColumnModal } from "view/components/Modals/Community/CommunitiesColumnModal";
import FiltersList from "../FiltersList";
import HeaderBar from "./components/HeaderBar";
// Store Utils
import { useSelector } from "react-redux";
import { RootState } from "store";
// types
import { FiltersProps } from "./types";
import { IfetchCommunities } from "store/communities/initialState";
import { filtersInitialState } from "store/filters/initialState";
import { isAnyCommunityFilterApplied } from "../AppliedFilters";
import { getFiltersDataFromLocalStorage } from "utils/cacheOrRetriveFiltersDate";

export const Filters: React.FC<FiltersProps> = ({
  columnOrder,
  setColumnOrder,
  columns,
  columnVisibility,
  setColumnVisibility,
  setColumnsConfig,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCloseDiv, setIsCloseDiv] = useState(false);
  const { data } = useSelector<RootState, IfetchCommunities>(
    (state) => state?.allCommunities
  );

  // Getting communitiesFilter state from Redux store
  const { communitiesFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  // Handlers
  const handleToggleDropdown = () => {
    setIsCloseDiv((prevState) => !prevState);
  };

 


  useEffect(() => {
    const filtersData = getFiltersDataFromLocalStorage();
    setIsCloseDiv((pre: any) => {
      if (filtersData !== undefined) {
        return isAnyCommunityFilterApplied(filtersData.filters);
      } else {
        return isAnyCommunityFilterApplied(communitiesFilter);
      }
    });
  }, []);
  return (
    <>
      <div className="flex flex-col items-start justify-start w-full gap-2">
        <HeaderBar
          data={data}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          handleToggleDropdown={handleToggleDropdown}
          isCloseDiv={isCloseDiv}
        />
        <FiltersList isCloseDiv={isCloseDiv} />
      </div>
      {isOpen && (
        <CommunitiesColumnModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          columnOrder={columnOrder}
          setColumnOrder={setColumnOrder}
          columns={columns.filter((item: any) => item.id !== "select")}
          columnVisibility={columnVisibility}
          setColumnVisibility={setColumnVisibility}
        />
      )}
    </>
  );
};
